var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import theme from '~/styles/theme';
export function AppProvider(_a) {
    var children = _a.children;
    return (_jsxs(_Fragment, { children: [_jsx(ColorModeScript, { initialColorMode: theme.config.initialColorMode }, void 0),
            _jsx(ChakraProvider, __assign({ theme: theme }, { children: children }), void 0)] }, void 0));
}
